import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MplusActiveIcon from 'shared/icons/mplus/mplus_active.webp'
import { priceShow } from 'shared/lib/priceShow'

import s from './styles.module.scss'

interface Props {
  price: string
  isActive?: boolean
  onClick?: () => void
}

export const ActiveMplusCard = ({ price, isActive, onClick }: Props) => {
  const { t } = useTranslation()
  return (
    <div
      onClick={onClick}
      className={clsx(s.disabledMplusCard, isActive && s.activeCard)}
    >
      <div className={s.icon}>
        <img src={MplusActiveIcon} />
      </div>

      <p className={clsx(s.title, 'semi-bold-14')}>{t('mplus.take_mplus')}</p>

      <p className={clsx(s.description, 'regular-12')}>
        {t('mplus.current_free', { price: priceShow(price) })}
      </p>
    </div>
  )
}
